import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';

import Link from '../Link';

export const BreadcrumbItem = styled('span')`
  ${mediaQueries[0]} {
    font-size: ${({ theme }) => theme.fontSize.xs};
  }

  ${mediaQueries.min} {
    font-size: ${({ theme }) => theme.fontSize.s};
  }

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.m};
  }
`;

export const BreadcrumbLink = styled(Link)`
  &:hover {
    color: #035c67;
  }

  ${mediaQueries[0]} {
    font-size: ${({ theme }) => theme.fontSize.xs};
  }

  ${mediaQueries.min} {
    font-size: ${({ theme }) => theme.fontSize.s};
  }

  ${mediaQueries.desktop} {
    font-size: ${({ theme }) => theme.fontSize.m};
  }
`;
